<template lang="pug">
div.pt-3.pb-8
  general-company-info
  v-divider.basic500.my-5
  general-page-language
  v-divider.basic500.my-5
  general-date-picker-view
  v-divider.basic500.my-5
  general-email-confirmation
  v-divider.basic500.my-5
  general-manual-payment

</template>

<script>
import GeneralCompanyInfo from '@/components/clinic/manage/GeneralCompanyInfo.vue'
import GeneralPageLanguage from '@/components/clinic/manage/GeneralPageLanguage.vue'
import GeneralDatePickerView from '@/components/clinic/manage/GeneralDatePickerView.vue'
import GeneralEmailConfirmation from '@/components/clinic/manage/GeneralEmailConfirmation.vue'
import GeneralManualPayment from '@/components/clinic/manage/GeneralManualPayment.vue'

export default {
  name: 'ManageGeneral',
  components: { GeneralCompanyInfo, GeneralPageLanguage, GeneralDatePickerView, GeneralEmailConfirmation, GeneralManualPayment },
}
</script>

<style scoped>

</style>